import { render, staticRenderFns } from "./TourialLogo.vue?vue&type=template&id=22680fe8&scoped=true&"
import script from "./TourialLogo.vue?vue&type=script&lang=js&"
export * from "./TourialLogo.vue?vue&type=script&lang=js&"
import style0 from "./TourialLogo.vue?vue&type=style&index=0&id=22680fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22680fe8",
  null
  
)

export default component.exports